import fr from 'facet-rest';
import GoalFormPriorityButtonGroup from 'Components/UI/Overrides/GoalFormPriorityButtonGroup';
import GoalFormDescriptionField from 'Components/UI/Overrides/GoalFormDescriptionField';
import FormattedNumberInput from 'Components/UI/Overrides/FormattedNumberInput';

const hiddenFieldNames = [
  'householdId',
  'icon',
  'completed',
  'notes',
  'status',
  'timeHorizonType',
  'timeHorizonValue',
  'startDate',
  'percentComplete',
  'bestNextStep',
  'flowStatus',
  'isMissingData',
  'updatedAt',
];

const GoalFormOverride = fr.metaOverride()
  .nameOverride(hiddenFieldNames, { hidden: true })
  .nameOverride('description', { _component: () => GoalFormDescriptionField })
  .nameOverride('priority', { _component: () => GoalFormPriorityButtonGroup })
  .nameOverride('amount', {
    materialInputProps: {
      InputProps: {
        inputComponent: FormattedNumberInput,
        inputProps: {
          decimalScale: 0,
        },
      },
    },
    _customProps: { helperText: 'Total amount for this goal' },
  })
  .nameOverride('amountSaved', {
    materialInputProps: {
      InputProps: {
        inputComponent: FormattedNumberInput,
        inputProps: {
          decimalScale: 0,
        },
      },
    },
  })
  .nameOverride('endDate', {
    _customProps: {
      helperText: 'When to accomplish this goal',
      openTo: 'year',
    },
  });

export default GoalFormOverride;
